/**
 * @author Mohit Kukreja <mohit.kukreja@314ecorp.com>
 * @description React Hook useTenantPayers
 */
import { useQuery, UseQueryResult } from '@tanstack/react-query';

import api from 'client/index';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * useTenantPayers hook
 * @returns {UseQueryResult} useTenantPayers
 */
const useTenantPayers = (): UseQueryResult<Payers.ITenantPayer[]> => {
	return useQuery({
		queryKey: [QUERY_KEYS.tenantPayers],
		queryFn: async () => {
			const { data } = await api.TenantPayerApi.getTenantPayers();
			return data;
		},
	});
};

export default useTenantPayers;
